import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Select from '../../components/BaseSelect';

import { selectNetwork } from './networksSlice';

import { selectTransferType } from '../transferTypes/transferTypesSlice';
import { resetToStep } from '../step/stepSlice';

const CustomOption = ({ selectProps, isSelected, innerProps, data, children }) => {
  let className = `${selectProps.classNamePrefix}__option`;

  if (isSelected) {
    className += ' react-select__option--is-selected';
  }

  return (
    <div className={className} {...innerProps} style={{ display: 'flex', alignItems: 'center' }}>
      <img alt={data.name} src={data.logoLink} style={{ margin: '9px 16px' }} />
      <div>{data.name}</div>
    </div>
  );
};

const SingleValue = ({ children, hasValue, getValue, selectProps }) => {
  let className = `${selectProps.classNamePrefix}__single-value`;
  const data = getValue()[0];

  if (!hasValue) {
    return null;
  }
  return (
    <div style={{ display: 'flex', alignItems: 'center', marginTop: -12 }}>
      <img className={className} alt={data.name} src={data.logoLink} />
      <div>{data.name}</div>
    </div>
  );
};

export default function NetworkSelect() {
  const { networks, selected } = useSelector((state) => state.networks);
  const dispatch = useDispatch();

  const onNetworkSelect = (o) => {
    dispatch(selectTransferType(1)); //reset to "Top up"
    dispatch(resetToStep(2)); //reset form to ReceiverNetwork

    dispatch(selectNetwork(o));
  };

  return (
    <div className="form-group">
      <Select
        value={selected}
        onChange={onNetworkSelect}
        className="network-select"
        options={networks}
        components={{ Option: CustomOption, SingleValue }}
        isSearchable={false}
        // open={true}
      />
    </div>
  );
}
